import React from 'react';
import { Link } from 'react-router-dom';

import { Button, Typography } from 'antd';

import ChargebackAlert from 'v2/components/Shared/ChargebackAlert';

import { Icon } from '@eduzz/ui-antd-theme';

interface IProps {
  title: string | React.ReactNode;
  extra?: React.ReactNode;
  helpLink?: string;
  helpText?: string;
  goBackTo?: string;
  action?: React.ReactNode;
  additionalContent?: React.ReactNode;
  disableAlerts?: boolean;
}

function TopPage({
  title,
  extra,
  helpLink,
  helpText = 'Ajuda',
  goBackTo,
  action,
  additionalContent,
  disableAlerts = false
}: IProps) {
  return (
    <>
      {!disableAlerts && <ChargebackAlert />}

      <div className='relative mt-2 mb-6 flex items-start justify-between gap-4 max-sm:flex-col'>
        <div className='flex min-w-0 grow flex-col gap-2'>
          <div className='flex items-center gap-6'>
            {!!goBackTo && (
              <Link
                to={goBackTo}
                id='go-back-button'
                className='inline-flex shrink-0 items-center gap-1 text-sm text-(--uizz-antd-color-text-secondary) hover:text-(--uizz-antd-color-primary)'
              >
                <Icon.ArrowLeft size={16} aria-hidden='true' />
                Voltar
              </Link>
            )}
            <Typography.Title level={3} className='m-0 text-[[1.25rem] leading-7 font-semibold'>
              {title}
            </Typography.Title>
          </div>
          {!!extra && (
            <Typography.Text type='secondary' className='text-base'>
              {extra}
            </Typography.Text>
          )}
        </div>

        {(!!action || additionalContent || !!helpLink) && (
          <div className='flex shrink-0 flex-wrap items-center gap-2'>
            {!!action && action}
            {additionalContent}
            {!!helpLink && (
              <Button
                color='default'
                variant='filled'
                size='middle'
                href={helpLink}
                target='_blank'
                rel='noopener noreferrer'
              >
                {helpText}
              </Button>
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default TopPage;
